// extracted by mini-css-extract-plugin
export var modal = "index-module--modal--Xr7Lj";
export var modalPriceAndLogo = "index-module--modalPriceAndLogo--OwIII";
export var modalOpen = "index-module--modalOpen--2Yfy3";
export var modalPortal = "index-module--modalPortal--143Fi";
export var left = "index-module--left--2KeEi";
export var icelandairLogo = "index-module--icelandairLogo--JvQnG";
export var icelandairContainer = "index-module--icelandairContainer--WXEw2";